/**
Author - Babajan Patan
Git - https://github.com/babajanpatan
* */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

const Checkbox = ({checked, onChange, disabled, label}) => {
  return (
    <CheckboxContainer>
      <Input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <CustomCheckbox disabled={disabled}>
        {checked && <Checkmark>&#10003;</Checkmark>}
      </CustomCheckbox>
      <Label>{label}</Label>
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  gap: 0px;
`;

const Input = styled.input`
  display: none; // Hiding the default checkbox
`;

const CustomCheckbox = styled.span`
  width: 20px;
  height: 20px;
  border: 2px solid #7e53ed;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.disabled ? "#f1ecfb" : "#fff")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  margin-right: 8px;
`;

const Checkmark = styled.span`
  color: #7e53ed;
  font-size: 16px;
`;

const Label = styled.span`
  font-size: 14px;
`;

Checkbox.propTypes = propTypes;

export default Checkbox;
